import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';

import {IgoSharedModule} from '../shared';
import {IgoContextModule} from '../context/module';
import {IgoDataSourceModule} from '../datasource';
import {IgoFeatureModule} from '../feature';
import {IgoFilterModule} from '../filter';
import {IgoLayerModule} from '../layer';
import {IgoMapModule} from '../map';
import {IgoCatalogModule} from '../catalog';
import {IgoImportExportModule} from '../import-export';
import {IgoPrintModule} from '../print';
import {IgoShareMapModule} from '../share-map';

import {ToolService} from './shared';
import {ToolbarBindingDirective, ToolbarComponent} from './toolbar';
import {ToolbarItemComponent} from './toolbar-item';
import {ToolboxComponent} from './toolbox';

import {
  CatalogLayersToolComponent,
  CatalogToolComponent,
  ContextEditorToolComponent,
  ContextManagerToolComponent,
  FeatureDetailToolComponent,
  ImportExportToolComponent,
  MapDetailsToolComponent,
  OgcFilterToolComponent,
  PermissionsContextManagerToolComponent,
  PrintToolComponent,
  SearchResultsToolComponent,
  ShareMapToolComponent,
  TimeAnalysisToolComponent,
  ToolsContextManagerToolComponent
} from './tools';
import {HomePageComponent} from './tools/home-page';
import {EtloutsideInfoService} from './tools/home-page/etloutside-info.service';


const IGO_TOOLS = [
  ContextManagerToolComponent,
  ContextEditorToolComponent,
  ImportExportToolComponent,
  ToolsContextManagerToolComponent,
  PermissionsContextManagerToolComponent,
  MapDetailsToolComponent,
  CatalogToolComponent,
  CatalogLayersToolComponent,
  SearchResultsToolComponent,
  PrintToolComponent,
  ShareMapToolComponent,
  TimeAnalysisToolComponent,
  OgcFilterToolComponent,
  FeatureDetailToolComponent,
  HomePageComponent
];

@NgModule({
  imports: [
    IgoSharedModule,
    IgoContextModule,
    IgoDataSourceModule,
    IgoFeatureModule,
    IgoFilterModule,
    IgoLayerModule,
    IgoMapModule,
    IgoCatalogModule,
    IgoImportExportModule,
    IgoPrintModule,
    IgoShareMapModule
  ],
  exports: [
    ToolbarComponent,
    ToolbarBindingDirective,
    ToolbarItemComponent,
    ToolboxComponent,

    ...IGO_TOOLS
  ],
  declarations: [
    ToolbarComponent,
    ToolbarBindingDirective,
    ToolbarItemComponent,
    ToolboxComponent,

    ...IGO_TOOLS
  ],
  providers: [EtloutsideInfoService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: IGO_TOOLS
})
export class IgoToolModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IgoToolModule,
      providers: [
        ToolService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/module.ts